import React from "react";

export default class Tempeture extends React.Component {
  componentDidMount() {
    this.caller = setInterval(this.props.handle, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.caller);
  }

  render() {
    return (
      <div className="healthcheck">
        <h2>하단의 체온계에서 체온을 측정해 주세요</h2>
        <div className="healthcheck-container">
          <div className="healthcheck-tb">
            <div className="healthcheck-td" id="s-cover">
              <div className="healthcheck-button">
                <img
                  src="https://img.icons8.com/emoji/48/000000/thermometer-emoji.png"
                  alt="체온"
                />
              </div>
            </div>
            <div className="healthcheck-td">
              <input
                value={this.props.value}
                type="text"
                placeholder="체온"
                name="tempeture"
                required
                onChange={this.props.change}
              />
            </div>
            <div className="healthcheck-td">
              <p>℃</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
